import React, { useEffect } from 'react';
import DrawerComponent from '../Drawer';
import { useDispatch, useSelector } from 'react-redux';
import { toggleNavbar } from './slices/navbar.slice';
import home_icon from '../../assets/Image 1/DCLogoVector2.svg';
import analysis_icon from '../../assets/Image 1/analytics.svg';
import chat_icon from '../../assets/Image 1/chat-manager.svg';
import chatBotFace_icon from '../../assets/Image 1/chatbot.svg';
import template_icon from '../../assets/Image 1/template.svg';
import share_icon from '../../assets/Image 1/share.svg';
import chatbot_builder from '../../assets/Image 1/chatbot-builder.svg';
import teams_icon from '../../assets/Image 1/campign-manager.svg';
import user_icon from '../../assets/Image 1/user.svg';
import team_icon from '../../assets/Image 1/team.svg';
import users_icon from '../../assets/Image 1/whatsapp.svg';
import channel_icon from '../../assets/Image 1/channel.svg';
import tags_icon from '../../assets/Image 1/contacts.svg';
import star_icon from '../../assets/Image 1/star.png';
import billing_icon from '../../assets/Image 1/billing.svg';
import setting_icon from '../../assets/Image 1/settings.svg';
import logo from '../../assets/dc-logo-latest.png';
// import logo from '../../assets/quantica.png';
import { STRINGS } from '../../utils/base';
import '../../App.css';

import { Link, useLocation } from 'react-router-dom';

const navbarData = [
   {
      icon: home_icon,
      value: 'Home',
      isBlank: false,
      route: `${STRINGS.ROUTES.ROOT}?org=${localStorage.getItem('userId')}`,
   },
   {
      icon: analysis_icon,
      value: 'Insights',
      isBlank: true,
      route: `http://localhost:8090/eoceanwab/customerstatistics/index`,
   },
   {
      icon: chat_icon,
      value: 'Chat Manager',
      isBlank: true,
      route: `http://localhost:8090/eoceanwab/chatmanager/index`,
   },
   {
      icon: chatbot_builder,
      value: 'Chatbot builder',
      isBlank: true,
      route: `http://localhost:8090/eoceanwab/chatbotbuilder/index`,
   },
   {
      icon: channel_icon,
      value: 'Channels',
      isBlank: true,
      route: `${process.env.REACT_APP_PORTAL_URl}/eoceanwab/channels/index`,
   },
   {
      icon: channel_icon,
      value: 'Complain',
      isBlank: true,
      route: `${process.env.REACT_APP_PORTAL_URl}/eoceanwab/complain/index`,
   },
   {
      icon: teams_icon,
      value: 'Profile Settings',
      isBlank: true,
      route: ` http://localhost:8090/eoceanwab/Settings/profilesettings`,
   },
   {
      icon: users_icon,
      value: 'Settings',
      isBlank: false,
      route: `${STRINGS.ROUTES.SETTINGS}?org=${localStorage.getItem('userId')}`,
   },

   {
      icon: tags_icon,
      value: "What's New",
      isBlank: true,
      route: `http://localhost:8090/eoceanwab/whatsnew/index`,
   },
];

const NavBar = () => {
   const userData = localStorage.getItem('user') && localStorage.getItem('user') != undefined ? 
   JSON.parse(localStorage.getItem('user')) : {};

   const location = useLocation();
   console.log(location.pathname);
   const navbar = useSelector(({ Reducers }) => Reducers.navbar);
   let { open } = navbar;
   const [openConversation, setOpenConversation] = React.useState(false);
   const [menuList, setMenuList] = React.useState([]);
   const dispatch = useDispatch();

   const toggleDrawer = () => {
      dispatch(toggleNavbar(false));
   };

   useEffect(()=>{
      if(userData && !userData.is_revamp_enabled){
         setMenuList([
            {
               route: process.env.REACT_APP_PORTAL_URl+"/holisticanalysis/index", 
            },
            {
               route: `${process.env.REACT_APP_PORTAL_URl}/chatmanager/index?number=&type=&id=`, 
            },
            {
               route: process.env.REACT_APP_PORTAL_URl+"/chatbotmanager/index", 
            },
            {
               route: process.env.REACT_APP_PORTAL_URl+"/campaignmessages/index?msgType=", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/segments/index?segmentName=&segmentType=&createdOn=", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/contacts/index?name=&number=&email=&status=&customAttributes=&pageSize=", 
            },{
               route: `${STRINGS.ROUTES.ROOT}?org=${localStorage.getItem('userId')}`, 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/channels/index", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/integrations/index", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/usermanagement/summary", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/teammanagement/summary?teamName=&status=", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/WhatsappManager/profilesettings", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/billing/index", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/accountsettings/index", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/whatsnew/index", 
            },
         ])
      } else {
         setMenuList([
            {
               route: "https://webapp.digiconn.co/insights", 
            },
            {
               route: "https://webapp.digiconn.co/conversations", 
            },
            {
               route: "https://webapp.digiconn.co/botConversations", 
            },
            // {
            //    route: "https://webapp.digiconn.co/conversations/call-logs", 
            // },
            {
               route: process.env.REACT_APP_PORTAL_URl+"/campaignmessages/index?msgType=", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/segments/index?segmentName=&segmentType=&createdOn=", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/contacts/index?name=&number=&email=&status=&customAttributes=&pageSize=", 
            },{
               route: `${STRINGS.ROUTES.ROOT}?org=${localStorage.getItem('userId')}`, 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/channels/index", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/integrations/index", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/usermanagement/summary", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/teammanagement/summary?teamName=&status=", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/WhatsappManager/profilesettings", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/billing/index", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/accountsettings/index", 
            },{
               route: process.env.REACT_APP_PORTAL_URl+"/whatsnew/index", 
            },
         ])
      }
   }, [])

   return (

      <div className="vertical-layout vertical-menu-modern content-left-sidebar navbar-floating footer-static menu-collapsed" data-open="click" data-menu="vertical-menu-modern" data-col="content-left-sidebar">
      <div className="pace  pace-inactive"><div className="pace-progress" data-progress-text="100%" data-progress="99">
  <div className="pace-progress-inner"></div>
</div>
<div className="pace-activity"></div></div>
      <div id="main-menu" className="main-menu menu-fixed menu-light menu-accordion menu-shadow menu-dark"
         data-scroll-to-active="true">
      <div className="navbar-header menu-collapsed">
        <ul className="nav navbar-nav flex-row">
          <li className="nav-item mr-auto" style={{marginRight: 'auto'}}>

            <a className="navbar-brand m-0 p-0" href="../../../html/ltr/vertical-menu-template/index.html">
              <span style={{ width: '190px' }}>
                <img src={logo} alt="Chatbot" style={{ marginTop: '0px', maxWidth: '100%', width: '50%' }} className="half-logo d-none" />
              </span>
            </a>
            <a className="navbar-brand m-0" href="../../../html/ltr/vertical-menu-template/index.html">
              <span className="brand-logo" style={{ width: '190px' }}>
                <img src={logo} alt="Chatbot" style={{ maxWidth: '40px' }} className="full-logo" />
              </span>
            </a>
          </li>
          {/* <li className="nav-item nav-toggle">
            <a className="nav-link modern-nav-toggle pr-0" data-toggle="collapse">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-x d-block d-xl-none text-white toggle-icon font-medium-4">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-disc d-none d-xl-block collapse-toggle-icon primary text-white font-medium-4">
                <circle cx="12" cy="12" r="10" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </a>
          </li> */}

         <li class="nav-item nav-toggle">
            <a class="nav-link modern-nav-toggle pr-0" data-toggle="collapse" style={{display: 'block', background: '#0000'}}>
               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-circle d-none d-xl-block collapse-toggle-icon font-medium-4" style={{
                  width: '19px'
               }}>
            <circle className='toggled-menu d-none' cx="12" cy="12" r="3"></circle>
            <circle cx="12" cy="12" r="10"></circle></svg> </a>
         </li>

        </ul>
      </div>
      <div class="shadow-bottom"></div>
       <div class="main-menu-content ps ps--active-y">
          <ul class="navigation navigation-main scroll_navBar" id="main-menu-navigation"
             data-menu="menu-navigation">
                <li id="statsLi" class="nav-item">
                   <a
                   class="d-flex align-items-center"
                   href={menuList[0]?.route}> 
                   {/* <i class="fa-solid fa-chart-simple"></i> */}
                   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-no-axes-combined-icon lucide-chart-no-axes-combined"><path d="M12 16v5"></path><path d="M16 14v7"></path><path d="M20 10v11"></path><path d="m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15"></path><path d="M4 18v3"></path><path d="M8 14v7"></path></svg>

                   <span
                      class="menu-item text-truncate" data-i18n="Analytics">Insights</span>
                   </a>
                </li>

                <li className={`nav-item ${openConversation ? 'open' : ''}`}>
                  <a
                     href="#"
                     className="d-flex align-items-center relative"
                     onClick={() => {
                        setOpenConversation(!openConversation)
                     }}
                  >
                     {/* <i className="fas fa-comments"></i> */}
                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet" stroke="currentColor" stroke-width="25" stroke-linecap="round" stroke-linejoin="round" fill="currentColor" width="24" height="24">
                     <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
                        <path d="M3085 4903 c-213 -17 -471 -103 -639 -211 -219 -141 -410 -351 -523 -575 -48 -96 -108 -284 -127 -396 -30 -180 -18 -440 30 -611 26 -97 82 -233 128 -313 l45 -78 -105 -265 c-58 -147 -104 -279 -104 -297 0 -38 30 -72 70 -81 18 -5 103 25 299 103 l274 110 28 -20 c16 -11 73 -41 126 -66 56 -26 120 -66 148 -91 167 -149 379 -258 623 -319 99 -25 123 -27 312 -28 161 0 223 4 290 18 152 33 296 87 426 160 l60 35 235 -94 c313 -126 311 -126 349 -113 30 11 60 52 60 83 0 9 -48 135 -106 281 l-106 265 65 133 c117 235 152 386 151 647 0 195 -18 305 -75 467 -125 354 -400 659 -735 814 -49 23 -114 63 -144 88 -304 259 -680 386 -1055 354z m344 -198 c435 -83 804 -405 945 -825 46 -138 60 -234 60 -395 0 -264 -64 -475 -213 -700 -61 -93 -228 -260 -321 -322 -418 -280 -926 -292 -1355 -34 -46 28 -92 51 -101 51 -9 0 -102 -34 -207 -75 -104 -42 -191 -74 -193 -72 -2 2 30 87 71 190 41 103 75 197 75 209 0 12 -25 62 -55 112 -122 203 -175 397 -175 642 0 202 35 360 121 539 179 376 551 642 970 695 95 11 274 4 378 -15z m1245 -792 c298 -396 325 -948 67 -1377 -31 -51 -51 -97 -51 -115 0 -16 32 -111 71 -211 39 -99 69 -183 67 -185 -2 -3 -88 29 -191 70 -103 41 -195 75 -204 75 -10 0 -45 -16 -77 -36 -318 -191 -641 -245 -976 -163 -77 19 -225 73 -242 88 -4 3 40 7 96 8 557 10 1064 360 1279 883 139 338 140 730 1 1069 -20 47 -38 93 -41 101 -11 29 140 -126 201 -207z"></path>
                        <path d="M2447 3759 c-65 -10 -132 -52 -170 -106 -43 -60 -55 -97 -56 -169 -1 -77 41 -168 99 -214 115 -91 286 -78 382 28 53 59 71 105 71 187 1 84 -16 127 -72 188 -65 70 -157 101 -254 86z m118 -199 c21 -18 38 -68 31 -96 -19 -75 -111 -100 -167 -45 -21 21 -29 39 -29 64 0 41 39 94 73 99 26 4 74 -7 92 -22z"></path>
                        <path d="M3147 3759 c-139 -22 -235 -147 -225 -292 5 -77 30 -130 85 -184 102 -98 278 -98 381 0 58 55 86 121 85 202 0 83 -18 129 -74 190 -63 68 -156 99 -252 84z m113 -194 c5 -3 17 -20 26 -37 13 -26 14 -38 5 -69 -14 -47 -44 -69 -94 -69 -52 0 -97 43 -97 93 0 41 39 94 73 99 22 4 68 -5 87 -17z"></path>
                        <path d="M3847 3759 c-133 -21 -228 -138 -226 -278 1 -67 14 -105 56 -164 46 -67 108 -99 199 -105 91 -6 149 14 210 70 201 186 34 521 -239 477z m114 -194 c6 -4 18 -23 26 -42 11 -27 12 -42 3 -69 -15 -44 -45 -64 -96 -64 -82 0 -123 94 -69 159 33 39 88 45 136 16z"></path>
                        <path d="M639 3720 c-92 -16 -190 -83 -402 -274 -134 -121 -182 -182 -203 -254 -21 -71 -15 -129 31 -297 196 -713 769 -1500 1490 -2043 414 -312 831 -520 1234 -617 130 -30 175 -29 257 11 90 43 385 367 451 494 25 50 28 65 28 155 0 94 -2 103 -33 161 -18 34 -48 75 -65 92 -69 65 -628 451 -680 468 -64 22 -185 23 -243 1 -23 -8 -108 -54 -189 -101 -81 -47 -150 -86 -153 -86 -11 0 -242 193 -365 305 -174 159 -528 550 -554 612 -3 7 36 84 85 170 50 87 96 180 103 206 6 26 9 82 7 125 -6 104 -25 137 -270 482 -215 301 -251 340 -346 372 -62 21 -126 28 -183 18z m136 -191 c11 -4 30 -16 41 -26 24 -20 405 -556 430 -606 12 -21 15 -48 12 -91 -4 -56 -13 -76 -111 -244 -59 -101 -107 -195 -107 -208 0 -32 12 -54 68 -129 222 -294 553 -630 862 -875 139 -110 159 -122 195 -116 17 2 112 51 212 109 184 105 228 123 280 111 49 -12 82 -33 369 -236 307 -217 324 -234 324 -322 0 -26 -7 -61 -17 -79 -48 -94 -325 -400 -377 -417 -41 -13 -131 6 -317 66 -849 274 -1751 1077 -2193 1953 -129 257 -236 561 -239 683 l-2 57 85 87 c82 82 255 231 313 269 51 33 114 38 172 14z"></path>
                     </g>
                     </svg>
                     <span className="menu-title text-truncate"
                     onClick={() => {
                        setOpenConversation(!openConversation)
                     }}
                     >Conversations{openConversation}</span>

                     <i
                        className={`conversation-menu absolute ml-auto fas fa-chevron-${openConversation ? 'down' : 'right'}`}
                        style={{ fontSize: '12px' }}
                     ></i>
                  </a>

                  {/* Sub Menu */}
                  {true && (
                     <ul className="menu-content">
                        <li className="nav-item" style={{"margin-bottom": "0 !important"}}>
                        <a
                           href={menuList[1]?.route}
                           className="d-flex align-items-center pl-4"
                        >
                           <i className="far fa-envelope"></i>
                           <span className="menu-title">Inbox</span>
                        </a>
                        </li>
                        {
                           userData && userData.is_revamp_enabled === 1 &&
                              <li className="nav-item" style={{"marginBottom": "0 !important"}}>
                              <a
                                 href={"https://webapp.digiconn.co/conversations/call-logs"}
                                 className="d-flex align-items-center pl-4"
                              >
                                 <i className="far fa-envelope"></i>
                                 <span className="menu-title">Call Logs</span>
                              </a>
                              </li>
                           
                        }
                     </ul>
                  )}
               </li>

               <li id="templateManagerLi" class="nav-item">
                   <a id="chatAnchor"
                   class="d-flex align-items-center" href={menuList[2]?.route}>
                      {/* <i
                      class="far fa-file-alt"></i>  */}
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-bot-message-square-icon lucide-bot-message-square"><path d="M12 6V2H8"></path><path d="m8 18-4 4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z"></path><path d="M2 12h2"></path><path d="M9 11v2"></path><path d="M15 11v2"></path><path d="M20 12h2"></path></svg><span
                      class="menu-title text-truncate" data-i18n="Chat">Bot Conversations
                   </span>
                   </a> 
                </li>

                <li id="templateManagerLi" class="nav-item">
                   <a id="chatAnchor"
                   class="d-flex align-items-center" href={menuList[3]?.route}>
                      {/* <i
                      class="far fa-file-alt"></i>  */}
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-newspaper-icon lucide-newspaper"><path d="M15 18h-5"></path><path d="M18 14h-8"></path><path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2"></path><rect width="8" height="4" x="10" y="6" rx="1"></rect></svg> <span
                      class="menu-title text-truncate" data-i18n="Chat">Template
                   Manager
                   </span>
                   </a> 
                </li>
                <li id="campaignLi" class="nav-item">
                   <a id="chatAnchor"
                   class="d-flex align-items-center" href={menuList[4]?.route}> 
                   {/* <i class="fas fa-bullhorn"></i>  */}
                   
                   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-megaphone-icon lucide-megaphone"><path d="M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"></path><path d="M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14"></path><path d="M8 6v8"></path></svg>                   <span
                      class="menu-title text-truncate" data-i18n="Chat">Campaign
                   Manager</span>
                   </a>
                </li>
                {/* <li id="profileSettingsli" class="nav-item">
                   <a
                   href={process.env.REACT_APP_PORTAL_URl+"/WhatsappManager/profilesettings"}
                   class="d-flex align-items-center chatManagerAnc"> <i
                      class="fab fa-whatsapp ml-25"></i><span class="nav-header-primary">WhatsApp Profile<span class="pull-right"><b class="caret"></b></span>
                   </span>
                   </a>
                </li> */}

                <li class="contactsLi nav-item">
                   <a
                   class="d-flex align-items-center"
                   href={menuList[5]?.route}>
                     {/* <i class="fas fa-users"></i> */}
                     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-book-user-icon lucide-book-user"><path d="M15 13a3 3 0 1 0-6 0"></path><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"></path><circle cx="12" cy="8" r="2"></circle></svg>
                     <span class="menu-title text-truncate"
                      data-i18n="Contacts">Contacts</span></a>
                </li>


                <li id="chatobotBuilderLi" className={`nav-item ${(location.pathname === "/" || location.pathname.includes("/settings") )? 'active' : ''}`}>
                   <a id="chatAnchor"
                   class="d-flex align-items-center"
                   href={menuList[6]?.route}> 
                   {/* <i
                      class="fas fa-network-wired"></i>  */}
                     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-network-icon lucide-network"><rect x="16" y="16" width="6" height="6" rx="1"></rect><rect x="2" y="16" width="6" height="6" rx="1"></rect><rect x="9" y="2" width="6" height="6" rx="1"></rect><path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"></path><path d="M12 12V8"></path></svg>
                  
                   <span class="menu-title text-truncate" 
                      data-i18n="Chat">Bot Builder</span>&nbsp;  
                   </a>
                </li>
{/* 
                <li id="channelsLi" className={`nav-item ${location.pathname === "/complain" ? 'active' : ''}`}>
                   <a class="d-flex align-items-center"
                   href={`${STRINGS.ROUTES.COMPLAIN}`}><i class="fa fa-exclamation" style={{"text-align": "center"}}></i><span
                      class="menu-title text-truncate" data-i18n="complain">Complaint</span></a>
                </li> */}

                <li id="channelsLi" class=" nav-item">
                   <a class="d-flex align-items-center"
                   href={menuList[7]?.route}>
                     {/* <i class="fa fa-share-alt"></i> */}
                     
                     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-share2-icon lucide-share-2"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line></svg>
                     <span  class="menu-title text-truncate" data-i18n="channels">Channels</span></a>
                </li>
            
                <li id="integrationsLi" class="nav-item">
                   <a class="d-flex align-items-center"
                   href={menuList[8]?.route}>
                    {/* <i class="fas fa-cogs"></i> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-cog-icon lucide-cog"><path d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"></path><path d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"></path><path d="M12 2v2"></path><path d="M12 22v-2"></path><path d="m17 20.66-1-1.73"></path><path d="M11 10.27 7 3.34"></path><path d="m20.66 17-1.73-1"></path><path d="m3.34 7 1.73 1"></path><path d="M14 12h8"></path><path d="M2 12h2"></path><path d="m20.66 7-1.73 1"></path><path d="m3.34 17 1.73-1"></path><path d="m17 3.34-1 1.73"></path><path d="m11 13.73-4 6.93"></path></svg>
                    <span class="menu-title text-truncate" data-i18n="integrations">Integrations</span>
                    </a>
                </li>
             
               
                <li id="usermanagementLi" class="nav-item">
                   <a class="d-flex align-items-center"
                   href={menuList[9]?.route}>
                   {/* <i className='fa fa-shield'></i> */}
                   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-icon lucide-shield"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path></svg>                     <span class="menu-title text-truncate" data-i18n="Calendar">Users</span>
                   </a>
               </li>  

                  
              <li id="teammanagementLi" class=" nav-item"><a class="d-flex align-items-center"
              href={menuList[10]?.route}>
               {/* <i class="fas fa-user-friends"></i>                */}
               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users-icon lucide-users"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><path d="M16 3.128a4 4 0 0 1 0 7.744"></path><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><circle cx="9" cy="7" r="4"></circle></svg>               <span
                class="menu-title text-truncate" data-i18n="Todo">Teams</span></a></li>



            <li id="profileSettingsli" class="position_abs position_abs_b4 w-100 nav-item">
               <a
               href={menuList[11]?.route}
               class="d-flex align-items-center chatManagerAnc"> 
               <i
                  class="fab fa-whatsapp ml-25"></i>
                  <span class="nav-header-primary">WhatsApp Manager<span class="pull-right"><b class="caret"></b></span>
               </span>
               </a>
            </li>


            <li id="billingLi" class="position_abs position_abs_b1 w-100 nav-item"
               >
               <a class="d-flex align-items-center"
               href={menuList[12]?.route}>
               {/* <i class="fas fa-hand-holding-usd"></i>  */}
               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-badge-dollar-sign-icon lucide-badge-dollar-sign"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"></path><path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"></path><path d="M12 18V6"></path></svg>               <span
                  class="menu-title text-truncate" data-i18n="Kanban">Billing</span>
               </a>
            </li>
             <li id="accountSetLi" class="position_abs position_abs_b2 w-100 nav-item"
                >
                <a class="d-flex align-items-center"
                href={menuList[13]?.route}>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-settings-icon lucide-settings"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path><circle cx="12" cy="12" r="3"></circle></svg>                <span
                   class="menu-title text-truncate" data-i18n="Kanban">Settings</span> 
                </a>
             </li>
          
              <li id="whatsNewLi" class="position_abs position_abs_b3 w-100 nav-item">
                 <a class="d-flex align-items-center"
                 id="example" data-title="Here's What's New!!"
                 data-toggle="clickover" data-placement="right"
                 href={menuList[14]?.route}>
                 
                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-star-icon lucide-star"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                 <span class="menu-title text-truncate"
                    data-i18n="Kanban">What's New</span>  &nbsp;
                     <span
                    class="badge-custom-success badge badge-pill badge-primary float-right position-relative"
                    >New</span>
                 </a>
              </li>
          </ul>
       </div>
      </div>
      </div>
   );
};

export default NavBar;
